import React from "react";

import FullHeader from "./global/components/FullHeader";
import ThankYouCard from "./global/components/ThankYouCard";
import ThankYouIcon from "./assets/thankYou.png";
import PaymentFailed from "./assets/paymentFailed.png";

const StripeComplete = (props) => {
  return (
    <div className="stripeComplete-root">
      <FullHeader />

      {props.success ? (
        <div className="thankyou-container">
          <div className="ty-icon-section">
            <img
              src={ThankYouIcon}
              alt="thankyou-icon"
              className="thankyou-icon"
            />
            <p className="ty-txt">Thank you for your purchase!</p>
          </div>

          <div className="ty-card-container">
            <ThankYouCard
              stepNumber="1"
              stepName="Step-1"
              stepTxt="We will verify your Stripe purchase."
            />
            <ThankYouCard
              stepNumber="2"
              stepName="Step-2"
              stepTxt="Check your email for an invitation to FastRealty."
            />

            <ThankYouCard
              stepNumber="3"
              stepName="Step-3"
              stepTxt="You will need to change your temporary password when you first sign in "
            />
          </div>
        </div>
      ) : (
        <div className="paymentFailed-container">
          <img
            src={PaymentFailed}
            alt="payment-failed"
            className="payment-failed"
          />
          <p className="pay-fail">Payment Failed</p>
          <p className="pay-fail-reason">
            There has been an issue with your payment. Please contact us for
            assistance.
          </p>
        </div>
      )}

      <style>
        {`.makeStyles-App_root-3 {
        background: #F0F2F5 !important;
      }
      `}
      </style>
    </div>
  );
};

export default StripeComplete;
